import { apiClient } from "./api";
import firebase from "../common/firebase";

export const swingLibraryService = {
  async getSwingLibrarySettings({ userId }) {
    return apiClient.request("/api/swing-library/settings", {
      method: "POST",
      body: { userId },
      requireAuth: true,
    });
  },

  async updateSwingLibrarySettings({ userId, data }) {
    return apiClient.request("/api/swing-library/settings-update", {
      method: "POST",
      body: { userId, data },
      requireAuth: true,
    });
  },

  async addTag({ userId, tag, type }) {
    return apiClient.request("/api/swing-library/settings/tags", {
      method: "POST",
      body: { userId, tag, type },
      requireAuth: true,
    });
  },

  async updateVideoTags({ videoId, tag, type }) {
    return apiClient.request("/api/videos/tag/update", {
      method: "PATCH",
      body: { videoId, tag, type },
      requireAuth: true,
    });
  },

  async getIndicators({ subscriptionLevel }) {
    return apiClient.request(
      `/api/utility/action-sdk-indicators?subscriptionLevel=${encodeURIComponent(
        subscriptionLevel
      )}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  },

  // -------- Swing list / indicators --------
  async getSwingList(payload) {
    // interface SwingListPayload {
    //   userId?: string | string[]
    //   userFilter?: Array<{ userName: string; userId: string }>
    //   sort?: string
    //   order?: 'asc' | 'desc'
    //   limit?: number
    //   offset?: number
    //   dateRangeStart?: number
    //   dateRangeEnd?: number
    //   analyzed?: boolean
    //   domHand?: 'LEFT' | 'RIGHT'
    //   tags?: string[]
    //   enterpriseUserId?: string
    //   loadAll?: boolean
    //   indicators?: Array<{ id: string; name?: string }>
    // }

    return apiClient.request("/api/v4/swingList", {
      method: "POST",
      body: payload,
      requireAuth: true,
    });
  },

  async getSwingListCollections(payload) {
    // interface SwingListPayload {
    //   userId?: string | string[]
    //   sort?: string
    //   order?: 'asc' | 'desc'
    //   limit?: number
    //   offset?: number
    //   indicators?: Array<{ id: string; name?: string }>
    //   videoIds?: string[]
    // }

    return apiClient.request("/api/v2/swingListCollections", {
      method: "POST",
      body: payload,
      requireAuth: true,
    });
  },

  // POST /api/v2/swingListExport
  async exportSwingList({ userId, videoIds }) {
    return apiClient.request("/api/v2/swingListExport", {
      method: "POST",
      body: { userId, videoIds },
      requireAuth: true,
    });
  },

  // POST /api/swing-library/pdf-report
  async preparePdfReport({ videoIds, gender, height, golfClub }) {
    return apiClient.request("/api/swing-library/pdf-report", {
      method: "POST",
      body: { videoIds, gender, height, golfClub },
      requireAuth: true,
    });
  },

  // POST /api/swing-score-report/v1/
  async createSwingScoreReport({
    averageScore,
    clubCategory,
    clubName,
    coachId,
    report,
    reportURL,
    selectedGoals,
    swingResults,
    userId,
  }) {
    return apiClient.request("/api/swing-score-report/v1/", {
      method: "POST",
      body: {
        averageScore,
        clubCategory,
        clubName,
        coachId,
        report,
        reportURL,
        selectedGoals,
        swingResults,
        userId,
      },
      requireAuth: true,
    });
  },

  // POST /api/v1/credits
  async spendReportCredit({
    amount,
    creditCount,
    status,
    userId,
    coachId,
    transactionType,
    creditType,
  }) {
    return apiClient.request("/api/v1/credits", {
      method: "POST",
      body: {
        amount,
        creditCount,
        status,
        userId,
        coachId,
        transactionType,
        creditType,
      },
      requireAuth: true,
    });
  },

  async uploadPdfToReportsFolder(blob, fileName) {
    const ref = firebase
      .storage()
      .ref()
      .child(`swing-score-reports/${fileName}`);
    await ref.put(blob);
    return ref.getDownloadURL();
  },
};
